import { StatusId, OperationMS } from '../../types';
import { getDechiffrageInfo } from './historique';

// Droits et verrous d'ecran de l'Analyse, indexes sur l'id de statut de l'OPERATION
// (pas le nom, pas la string 'En attente' du legacy l.883/926). Une seule porte d'entree
// pour l'editabilite, partagee par toutes les feuilles (technique + synthese).

// Editable seulement quand l'operation est "A analyser" (4).
export const isAnalyseEditable = (idStatus?: number): boolean => idStatus === StatusId.AAnalyser;

// Analyse cloturee (A signer 13) ou operation validee/signee (11).
export const isAnalyseCloturee = (idStatus?: number): boolean =>
  idStatus === StatusId.ANotifier || idStatus === StatusId.Valider;

// Lecture seule de tout l'onglet : prop viewOnly OU statut non editable. Remplace les deux
// comparaisons objet-vs-string du legacy (toujours fausse / toujours vraie).
export const isAnalyseViewOnly = (operation: OperationMS, viewOnly = false): boolean =>
  viewOnly || !isAnalyseEditable(operation.status?.id);

export const isConsultationEnCours = (idStatus?: number): boolean =>
  idStatus === StatusId.ConsultationEnCours;

// Les plis sont-ils ouverts ? Soit l'operation a depasse "A analyser" (statut > 4), soit un
// evenement de dechiffrage existe dans l'historique.
export const isPlisOuverts = (operation: OperationMS): boolean =>
  getDechiffrageInfo(operation.historique).date !== null ||
  Number(operation.status?.id) > StatusId.AAnalyser;

// La section d'analyse des offres est verrouillee tant que la consultation tourne (2) ou
// tant que les plis ne sont pas dechiffres (4 + plis fermes).
export const isAnalyseSectionLocked = (operation: OperationMS): boolean => {
  const sid = operation.status?.id;
  const forceDechiffrage = sid === StatusId.AAnalyser && !isPlisOuverts(operation);
  return isConsultationEnCours(sid) || forceDechiffrage;
};
